import { render, staticRenderFns } from "./VehicleTable.vue?vue&type=template&id=3738b017&"
import script from "./VehicleTable.vue?vue&type=script&lang=js&"
export * from "./VehicleTable.vue?vue&type=script&lang=js&"
import style0 from "./VehicleTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports